var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchStr),expression:"searchStr"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":`Search ${_vm.title || ''}...`},domProps:{"value":(_vm.searchStr)},on:{"input":function($event){if($event.target.composing)return;_vm.searchStr=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }